export default __webpack_public_path__ + "media/images/avatars/avatar17-05423866dfab344c9b01c4cf9ec7bbd0.png";